import { jsonHeaders } from '#lib/helpers/fetch.js';
import useAuth from '#lib/hooks/use-auth.jsx';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';
import { useAuthQuery } from '#lib/hooks/use-query.js';
import toast from 'react-hot-toast';

async function fetchBillingInfo(_, authHeaders) {
    const response = await fetch(`${API_URL}/p/billingInfo`, {
        headers: { ...jsonHeaders, ...authHeaders }
    });
    return await response.json();
}

async function updateBillingInfo(model, authHeaders) {
    const response = await fetch(`${API_URL}/p/billingInfo`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(model)
    });
    return await response.json();
}

export default function useBillingInfo(setUnsavedChanges) {
    const { data, ...queryProps } = useAuthQuery({
        queryKey: ['billingInfo'],
        queryFn: fetchBillingInfo,
        staleTime: 1000,
        refetchOnWindowFocus: false
    });

    const save = useAuthMutation({
        mutationKey: ['billingInfo'],
        mutationFn: updateBillingInfo,
        staleTime: 1000,
        refetchOnWindowFocus: false,
        onSuccess: () => {
            toast.success(_t.billing.success());
            setUnsavedChanges(() => false);
        },
        onError: (e) => {
            toast.error(e.message);
        }
    });

    return {
        save,
        data: data?.result,
        ...queryProps
    };
}
